const writersSagaNamespace = 'writers-saga';
export const LOAD_WRITERS = `${writersSagaNamespace}/LOAD_WRITERS`;
export const ASSIGN_WRITERS_TO_REFERENCE = `${writersSagaNamespace}/ASSIGN_WRITERS_TO_REFERENCE`;
export const LOAD_CHAPTER_WRITERS = `${writersSagaNamespace}/LOAD_CHAPTER_WRITERS`;
export const CREATE_ASSIGNMENT = `${writersSagaNamespace}/CREATE_ASSIGNMENT`;
export const LOAD_ASSIGNMENTS = `${writersSagaNamespace}/LOAD_ASSIGNMENTS`;
export const LOAD_REFERENCES = `${writersSagaNamespace}/LOAD_REFERENCES`;
export const LOAD_ASSIGNMENT = `${writersSagaNamespace}/LOAD_ASSIGNMENT`;
export const UPDATE_ASSIGNMENT = `${writersSagaNamespace}/UPDATE_ASSIGNMENT`;
